import React, {useContext, useEffect, useMemo, useState} from 'react';
import {observer} from 'mobx-react-lite';
import {Context} from '../../../index';
import AddressStep from '../../../components/CheckoutSteps/AddressStep';
import CitySelectionModal from '../../../components/SelectCity/SelectCity';
import Modal from '../../../components/Modal/Modal';
import {fetchCitysForOrderModal} from '../../../http/settingsApi';
import PreorderDeliveryState from './PreorderDeliveryState';

const PreorderDelivery = observer(function PreorderDelivery({model, api, deliveryId}) {
  const original = useContext(Context);
  const selectionKey = JSON.stringify(model.cart.captureSelection());
  const state = useMemo(() => new PreorderDeliveryState({model, api, city: original.delivery.cityInfo}), [model, deliveryId, selectionKey]);
  const [cityOpen, setCityOpen] = useState(false), [cities, setCities] = useState(null);
  useEffect(() => () => state.dispose(), [state]);
  const cityKey = JSON.stringify(state.cityInfo);
  const optionsKey = JSON.stringify(model.options);
  useEffect(() => {state.load(deliveryId);}, [state, deliveryId, cityKey, optionsKey]);
  useEffect(() => {
    if (!cityOpen) return;
    let current = true;
    fetchCitysForOrderModal().then(value => {if (current && !value?.error) setCities(value);}).catch(() => {});
    return () => {current = false;};
  }, [cityOpen]);
  const context = {...original, delivery: state, basket: {delPrice: state.officePvz ? Number(state.calculation?.amountMinor) / 100 : 0}};
  const source = {points: state.points, pending: state.pending || model.locked, error: state.error,
    onSelect: state.selectPoint, onOpen: () => {if (!state.pending) state.load(deliveryId);}};
  return <Context.Provider value={context}>
    <fieldset disabled={model.locked}><AddressStep allowCourier={false} pickupSource={source}
      onChangeCity={() => {if (!model.locked) setCityOpen(true);}}/></fieldset>
    {state.pending && <p role="status">Обновляем доставку…</p>}
    {state.error && <p role="alert">{state.error}</p>}
    {cityOpen && <Modal onClose={() => setCityOpen(false)}><CitySelectionModal cityForOrder={cities} isOpen
      closeModal={() => setCityOpen(false)} setSityHandler={item => {if (!model.locked) state.setCityInfo(item.data ? item : {value: item.name, data: item});}}/></Modal>}
  </Context.Provider>;
});
export default PreorderDelivery;
